import { OrganizationPermission } from "../model/OrganizationModel";
import { IContextProfile } from "../model/UserModel";

export function verifyUserGuest(profile: IContextProfile): boolean {
    return profile?.signtureInformation?.allOrganizationUsers
                    .filter(user => user.permission == OrganizationPermission.GUEST)
                    .map(user => user.userId)
                    .includes(profile?.id!)!
}
